import { render } from "./EditPriceGroupView.vue?vue&type=template&id=5a3dfb00"
import script from "./EditPriceGroupView.vue?vue&type=script&lang=js"
export * from "./EditPriceGroupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__